import { FigureCard } from './FigureCard';
import type { Figure } from './policyFigures';

/** A per-occurrence policy's aggregate hail deductible. */
export function HailPerOccurrenceCard({ figures }: { figures: Figure[] }) {
  return <FigureCard title="Hail per occurrence" figures={figures} />;
}
